import { render, staticRenderFns } from "./LoginFlow.vue?vue&type=template&id=2b614eb4&scoped=true"
import script from "./LoginFlow.vue?vue&type=script&lang=js"
export * from "./LoginFlow.vue?vue&type=script&lang=js"
import style1 from "./LoginFlow.vue?vue&type=style&index=1&id=2b614eb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b614eb4",
  null
  
)

export default component.exports